// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__bAGJC","colMaxWidth":"Table_colMaxWidth__rhiFP"};